function getItem(profileId, productId, orderId) {
    return profileId + '_' + productId + '_' + orderId;
}

export default {
    namespaced: true,
    state: {
        orderId: null,
        orderedItems: [],
    },
    mutations: {
        setOrderId(state, value) {
            state.orderId = value;
        },
        addOrderedItem(state, { profileId, productId }) {
            const item = getItem(profileId, productId, state.orderId);
            if (!state.orderedItems.includes(item)) {
                state.orderedItems.push(item);
            }
        },
    },
    getters: {
        getOrderedItems(state) {
            return state.orderedItems;
        },
        isOrdered:
            (state) =>
            ({ profileId, productId }) => {
                const item = getItem(profileId, productId, state.orderId);
                return state.orderedItems.includes(item);
            },
    },
};
